import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { CONFIG } from '../../../../config'

const { ENVIROMENT } = CONFIG

const AssocUserOperacaoPatrimonialHttp = {
  baseURL: `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/patrimonio`,

  async getSistemaTelaInfo(usuario) {
    try {
      const url = this.baseURL + '/assoc-usuario-operacao-patrimonial/' + usuario.id
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getAssocByUserLocal(userLocalId) {
    try {
      const url = this.baseURL + '/assoc-usuario-operacao-patrimonial/associacoes/' + userLocalId
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async associacaoHandler(associacao) {
    try {
      const url = this.baseURL + '/assoc-usuario-operacao-patrimonial'
      const response = await authHttp().post(url, associacao)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
}

export default AssocUserOperacaoPatrimonialHttp
